<template>
  <div class="news-bg">
    <div class="banner-div">
      <img :src="require(`@/assets/images/${languages}/news/banner.jpg`)" />
    </div>
    <div class="main-box">
      <div class="news-list-box">
        <router-link to="/newDetails?id=0" class="news-list">
          <img :src="require(`@/assets/images/${languages}/news/list1.png`)" />
        </router-link>
        <router-link to="/newDetails?id=1" class="news-list">
          <img :src="require(`@/assets/images/${languages}/news/list2.png`)" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      resDatas: "",
    };
  },
  computed: {
    ...mapState(["languages"]), // 在这里引入你需要的state值
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.news-bg {
  height: 100%;
  background: url("~@/assets/images/traditional/news/bg.jpg") bottom center
    no-repeat;
  background-size: auto 100%;
}
.main-box {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 100px 0 100px;
}

.news-list-box {
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.news-list {
  margin-bottom: 100px;
  display: block;
}

@media screen and (max-width: 1000px) {
  .news-list-box {
    width: 90%;
    margin: auto;
  }

  .news-list {
    margin-bottom: 10%;
  }

  .news-list img {
    max-width: 100%;
  }

  .main-box {
    padding: 20% 0 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue